import { sendEvent } from 'helpers/analytics';
import {
  getChannelContextCode,
  getChannelContextMsg,
  getJsonStringify
} from 'helpers/Utility';
import { setError } from 'store/actions/auth';
import {
  applicationInquiry,
  setApplicationStatus,
  setBottomSheet,
  setNextDate,
  setWhitelistBottomSheet
} from 'store/actions/loanApply';

/**
 * to handle error payroll verification
 * @param {*} dispatch
 * @param {*} err
 * @param {*} auth
 * @param {*} history
 * @returns
 */
export const handleErrorPayrollVerification = (
  dispatch,
  err,
  auth,
  history
) => {
  const code = getChannelContextCode(err, 'channel-context');

  const referralSheetMap = {
    1041: {
      openBottomSheet: true,
      tittleBottomSheet: 'Kode referral tidak ditemukan',
      descriptionBottomSheet:
        'Silakan periksa kembali kode referral kamu atau lanjutkan tanpa menggunakan referral.'
    },
    1042: {
      openBottomSheet: true,
      tittleBottomSheet: 'Kode referral tidak aktif',
      descriptionBottomSheet:
        'Silakan periksa kembali kode referral kamu atau lanjutkan tanpa menggunakan referral.'
    },
    1043: {
      openBottomSheet: true,
      tittleBottomSheet: 'Kode referral tidak dapat digunakan',
      descriptionBottomSheet:
        'Silakan periksa kembali kode referral kamu atau lanjutkan tanpa menggunakan referral.'
    },
    1044: {
      openBottomSheet: true,
      tittleBottomSheet: 'Kode referral kedaluwarsa',
      descriptionBottomSheet:
        'Silakan periksa kembali kode referral kamu atau lanjutkan tanpa menggunakan referral.'
    }
  };

  if (referralSheetMap[code]) {
    dispatch(setBottomSheet(referralSheetMap[code]));
    return;
  }

  const validateWhitelistError = ['15003', '15004', '1027', '1026'];
  const validateWhitelist = code => {
    if (validateWhitelistError.includes(code)) {
      return {
        open: true,
        title: 'Data Tidak Sesuai',
        description:
          'Maaf data yang kamu masukan tidak sesuai. Silahkan hubungi Sapa Raya'
      };
    }
    return null;
  };

  const whitelistError = validateWhitelist(code);

  if (whitelistError) {
    dispatch(setWhitelistBottomSheet(whitelistError));
    return;
  }

  if (err?.response?.status === 422) {
    dispatch(setError('system'));
    dispatch(setApplicationStatus('APP_CREATED'));
    localStorage.removeItem('isExpired');
    return;
  }

  if (code === null) {
    dispatch(setError('system'));
    return;
  }

  if (code === '211101') {
    history?.push('/payroll-reject');
    return;
  }

  if (code === '1025') {
    dispatch(setError('curc_error'));
    const dateReset = getChannelContextMsg(err, 'channel-context')
      .split(' ')
      .pop();

    dispatch(setNextDate(dateReset));

    return;
  }

  const retryCodes = [
    '1008',
    '1009',
    '1010',
    '1011',
    '1012',
    '1013',
    '1014',
    '1015',
    '1017'
  ];

  if (retryCodes.includes(code)) {
    dispatch(setError('system'));
    dispatch(setApplicationStatus('APP_CREATED'));
    localStorage.removeItem('isExpired');
    dispatch(applicationInquiry(auth, history));
    return;
  }

  // unexpected error
  sendEvent({
    category: 'Error Payroll Verification',
    action: getJsonStringify(err.response),
    label: auth.phoneNo
  });

  if (!err.response) {
    dispatch(setError('connection'));
    return;
  }

  dispatch(setError('system'));
};
